export default __webpack_public_path__ + "static/media/linkedin.e4a53b6e851f3cd89f73d5c158a98739.svg";